// Register
export const SET_USERNAME = 'register/SET_USERNAME';
export const SET_EMAIL = 'register/SET_EMAIL';
export const SET_PASSWORD = 'register/SET_PASSWORD';
export const SET_PASSWORD_CONFIRM = 'register/SET_PASSWORD_CONFIRM';
export const UPDATE_STEP = 'register/UPDATE_STEP';


// WEBPACK FOOTER //
// ./resources/assets/js/external/store/mutation-types.js